// Minimap strings (Spanish) — must provide every key of minimapEn (checked by its type).

import type { minimapEn } from './minimapEn.js';

export const minimapEs: Record<keyof typeof minimapEn, string> = {
  'minimap.title': 'Minimapa',
  'minimap.aria':
    'Minimapa. Las flechas mueven el foco, Intro centra la cámara allí, C salta a la siguiente ciudad propia, más y menos acercan o alejan, cero ajusta todo el tablero.',
  'minimap.summary':
    'Minimapa: {cities} ciudades visibles, zoom {zoom}x, cámara en {camera}, foco {q},{r}: {what}',
  'minimap.cameraBox': 'Recuadro de la cámara',
  'minimap.zoomIn': 'Acercar',
  'minimap.zoomOut': 'Alejar',
  'minimap.fit': 'Ajustar tablero',
  'minimap.legend': 'Leyenda',
  'minimap.legendTitle': 'Leyenda del minimapa',
  'minimap.unexplored': 'Sin explorar',
  'minimap.coords': '({q}, {r})',
  'minimap.owner': 'Dueño: {owner}',
  'minimap.unclaimed': 'Sin dueño',
  'minimap.you': 'Tú',
  'minimap.city': 'Ciudad',
  'minimap.cityNamed': 'Ciudad {name}',
  'minimap.cityTier': 'Nivel {tier}',
  'minimap.capital': 'Capital',
  'minimap.village': 'Aldea neutral',
  'minimap.unitsOwn': 'Tus unidades: {count}',
  'minimap.unitsOther': 'Unidades: {count}',
  'minimap.explored': 'Explorado',
  'minimap.fog': 'Niebla',
  'minimap.unit': 'Unidad',
  'minimap.border': 'Frontera del territorio',
  'minimap.marker': 'Campeón',
  'minimap.layers': 'Capas',
  'minimap.layerTerritory': 'Territorio',
  'minimap.layerFog': 'Niebla de guerra',
  'minimap.layerUnits': 'Ciudades y unidades',
  'minimap.layerRivers': 'Ríos',
  'minimap.layerRelief': 'Relieve',
  'minimap.size': 'Tamaño',
  'minimap.sizeS': 'Pequeño',
  'minimap.sizeM': 'Mediano',
  'minimap.sizeL': 'Grande',
  'minimap.collapse': 'Plegar el minimapa',
  'minimap.expand': 'Desplegar el minimapa',
  'minimap.biome.river': 'Río',
};
